export default __webpack_public_path__ + "static/media/Infusion_Homepage.873e4bf8.png";